export const SearchFieldStyles = {
  searchIcon: {
    position: "absolute",
    right: "10px",
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
  },
  searchContainerTwo: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  errorMsg: {
    color: "red",
    fontSize: "12px",
    marginTop: "-13px",
    marginLeft: "12px",
  },
};
